<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-xl-10">
        <h3>
          Teams
          <small class="text-muted">
            <span v-if="!requesting">{{ teams.length }}</span>
            <i class="fa fa-fw fa-spinner fa-pulse" v-if="requesting"></i>
          </small>
        </h3>
      </div>
    </div>
    <div class="row" v-if="teams.length">
      <div class="col-12 col-xl-10">
        <table class="table table-sm table-bordered table-sm">
          <thead>
            <tr>
              <th width="15%">Name</th>
              <th>Postleitzahlen</th>
              <th class="text-center" width="1%">Löschen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="team in teams" :key="team._id">
              <td>{{ team.name }}</td>
              <td>{{ team.zipcodes }}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger btn-block" :disabled="requesting"
                  @click="onDelete(team._id)">
                  <i class="fa fa-fw fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="col col-xl-2">
        <div class="card">
          <div class="card-body">
           <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control form-control-sm" required v-model="name" />
              </div>
              <div class="form-group">
                <label for="zipcodes">Postleitzahlen</label>
                <select name="zipcodes" multiple v-model="zipcodes">

                </select>
              </div>
              <div class="form-group mb-0">
                <button type="submit" class="btn btn-block btn-success btn-sm" :disabled="requesting">Speichern</button>
              </div>
            </form> 
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getTeams, removeTeam } from '../../api';

export default {
  name: 'teams',
  data() {
    return {
      teams: [],
      requesting: false,
      name: '',
      zipcodes: []
    }
  },
  methods: {
    onSubmit() {
      console.log("Saving Team")
    },
    async onDelete(id) {
      this.requesting = true;

      try {
        this.teams = await removeTeam(id)
      } catch (e) {
        console.error(e)
      } finally {
        this.teams = await getTeams()
        this.requesting = false;
      }
    }
  },
  async created() {
    this.requesting = true;

    try {
      this.teams = await getTeams()
    } catch (e) {
      console.error(e)
    } finally {
      this.requesting = false;
    }
  }
}
</script>